/* HeavyHunt native wishlist — localStorage, no app, no dependencies. */
(function () {
  'use strict';

  var STORAGE_KEY = 'hh_wishlist_v1';
  var SAVED_CLASS = 'is-saved';
  var EVENT_NAME = 'hh:wishlist:change';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) { /* quota / private mode — silent */ }
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { list: list } }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function add(handle) {
    var list = read();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      write(list);
    }
  }

  function remove(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    write(list);
  }

  function syncButton(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var saved = has(handle);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.classList.toggle(SAVED_CLASS, saved);
    btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
    var textEl = btn.querySelector('[data-wishlist-text]');
    if (textEl) {
      textEl.textContent = saved
        ? (textEl.getAttribute('data-text-saved') || 'Saved')
        : (textEl.getAttribute('data-text-default') || 'Save');
    }
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
  }

  function syncCount() {
    var count = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.toggleAttribute('hidden', count === 0);
    });
  }

  function onToggleClick(event) {
    var btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    if (has(handle)) {
      remove(handle);
    } else {
      add(handle);
    }
  }

  /* Wishlist page rendering --------------------------------- */

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function moneyFormat(cents) {
    var Currency = (window.Shopify && window.Shopify.currency) || {};
    var code = Currency.active || 'USD';
    var rate = parseFloat(Currency.rate || '1');
    var amount = ((cents * rate) / 100).toFixed(2);
    return '$ ' + amount + ' ' + code;
  }

  function productCardHTML(p) {
    var image = (p.featured_image || (p.images && p.images[0]) || '');
    var imgTag = image
      ? '<img loading="lazy" src="' + image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">'
      : '';
    var url = '/products/' + p.handle;
    return (
      '<article class="hh-wl-card" data-wishlist-card data-handle="' + p.handle + '">' +
        '<a class="hh-wl-card__media" href="' + url + '">' + imgTag + '</a>' +
        '<div class="hh-wl-card__body">' +
          '<a class="hh-wl-card__title" href="' + url + '">' + (p.title || '') + '</a>' +
          '<div class="hh-wl-card__price">' + moneyFormat(p.price) + '</div>' +
          '<div class="hh-wl-card__actions">' +
            '<a class="hh-wl-card__view" href="' + url + '">View</a>' +
            '<button type="button" class="hh-wl-card__remove" data-wishlist-remove data-handle="' + p.handle + '" aria-label="Remove from wishlist">Remove</button>' +
          '</div>' +
        '</div>' +
      '</article>'
    );
  }

  function renderPage(root) {
    var list = read();
    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    grid.innerHTML = '<div class="hh-wl-loading">Loading your saved equipment…</div>';

    Promise.all(list.map(fetchProduct)).then(function (products) {
      var valid = products.filter(Boolean);
      // Drop any handles that 404'd (deleted/unpublished) so we don't keep retrying.
      if (valid.length !== list.length) {
        var validHandles = valid.map(function (p) { return p.handle; });
        var pruned = list.filter(function (h) { return validHandles.indexOf(h) !== -1; });
        write(pruned);
      }
      if (!valid.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }
      grid.innerHTML = valid.map(productCardHTML).join('');
    });
  }

  function onPageRemoveClick(event) {
    var btn = event.target.closest('[data-wishlist-remove]');
    if (!btn) return;
    event.preventDefault();
    var handle = btn.getAttribute('data-handle');
    if (handle) remove(handle);
    var card = btn.closest('[data-wishlist-card]');
    if (card) card.remove();
    var root = document.querySelector('[data-wishlist-page]');
    if (root && !read().length) {
      var empty = root.querySelector('[data-wishlist-empty]');
      var grid = root.querySelector('[data-wishlist-grid]');
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
    }
  }

  /* Init ---------------------------------------------------- */

  function init() {
    document.addEventListener('click', onToggleClick);
    document.addEventListener('click', onPageRemoveClick);
    document.addEventListener(EVENT_NAME, function () {
      syncAllButtons();
      syncCount();
    });
    syncAllButtons();
    syncCount();

    var wlPage = document.querySelector('[data-wishlist-page]');
    if (wlPage) renderPage(wlPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
